import React, { Component } from 'react';
import { AiOutlineSave } from 'react-icons/ai';

import * as Service from 'services/RestAPI';

import DefaultHeader from 'components/main/DefaultLayout/DefaultHeader';
import DefaultFooter from 'components/main/DefaultLayout/DefaultFooter';
import BoardHeader from './Layout/BoardHeader';
import BoardList from './Layout/BoardList';
import stl from "../reference/Layout/ReferenceHeader.module.scss";

class index extends Component {

    state = {
        data: []
    }

    componentDidMount() {
        this._getDataList();
    }

    _getDataList = async () => {
        await Service.getNoticeList().then((res) => {
            let resultList = [];
            res.data.map((item) => {
                const regDttm = new Date(item.ntDt);
                resultList.push({
                    rnum: item.rnum,
                    id: item.ntNo,
                    title: item.ntTitle,
                    writer: item.ntAuthor,
                    readNum: item.ntReadnum,
                    atchFile: item.ntFileSize !== undefined ? <AiOutlineSave style={{width: '30px', height: '30px'}}/> : '' ,
                    regDttm: regDttm.getFullYear() + '-' + (regDttm.getMonth() + 1) + '-' + appendZeroValue(regDttm.getDate())
                });
                return null;
            });
            this.setState({
                data: resultList
            });
        });
    }

    render() {
        return (
            <div>
                <DefaultHeader headerNavLink = {'notice'} target='page'/>
                {/*<div id={stl.breadcrumbs}>*/}
                    {/*<div className={stl.wrapper}>*/}
                        {/*<div id={stl.nav}>*/}
                            {/*<img src='/sis/images/main/board/navHome.png' id={stl.navHome}/>*/}
                            {/*&nbsp;&nbsp;<img src='/sis/images/main/board/navNext.png' id={stl.navNext}/>&nbsp;&nbsp; <span id={stl.navText}>공지사항</span>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
                {/*<div id={stl.iconWrapper}>*/}
                    {/*<div className={stl.iconContainer}>*/}
                        {/*<span className={stl.title}>공지사항</span>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <BoardHeader />
                <BoardList
                    data={this.state.data}
                    start={0}
                    viewCnt={10}
                    pageSize={5}
                    history={this.props.history}
                >
                    <div dataField='rnum' width={100} name="num">순번</div>
                    <div dataField='id' isKey width={100} hidden>ID</div>
                    <div dataField='title' width={600}>제목</div>
                    <div dataField='atchFile' width={100}>첨부파일</div>
                    <div dataField='writer' width={100}>작성자</div>
                    <div dataField='regDttm' width={100}>작성일</div>
                    <div dataField='readNum' width={100}>조회수</div>
                </BoardList>
                <DefaultFooter showSite/>
            </div>
        );
    }
}

function appendZeroValue(target) {
    if(target.toString().length === 1) {
        return "0" + target
    }else {
        return target
    }
}

export default index;